import React, { useState } from 'react';
import { Container } from "react-bootstrap";
import classes from '../pages.module.css';
import TextCol from '../../components/Ui/text/textCol';
import OptionList4 from '../../components/Ui/block/optionList4';
import iconDesign from '../../image/icon_design.png';
import iconAuto from '../../image/iconauto.png';
import iconSec from '../../image/icon_sec.png';
import iconArc from '../../image/iconarh.png';

const Nms5 = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Система Element Manager (EMS) для управления отдельным оборудованием с полной поддержкой FCAPS'},
        {id:2, content: 'North Bound Interfaces (NBI) для связи с внешними системами OSS'},
        {id:3, content: 'Системы управления сетью (NMS) для управления сервисами IP TDM'}
    ])
    const [options, setOptions] = useState([
        {id:1, title: 'Дизайн', src: (iconDesign), body: 'Дружественный и интуитивно понятный графический интерфейс с доступом через веб-браузер. Графическое представление топологии сети.', },
        {id:2, title: 'Безопасность', src: (iconSec), body: 'Варианты локального резервирования (питание, зеркалирование жесткого диска). Географическое резервирование системы для аварийного восстановления.', },
        {id:3, title: 'Архитектура', src: (iconArc), body: 'Распределенная архитектура NMS для балансировки нагрузки между несколькими серверами', },
        {id:4, title: 'Автоматизация', src: (iconAuto), body: 'Функции автоматического обнаружения сети', },
    ])
    return(
        <>
            <div className={classes.topBox}>
                <Container fluid="md">
                    <div className={classes.topboxBody}>
                        <span>радиорелейное оборудование</span>
                        <h1>NMS5-LX Management System</h1>
                        <p>Высокопроизводительная система управления сетью, разработанная для управления и контроля телекоммуникационных сетей. Управляет всеми радиопродуктами, а также и оборудованием сторонних производителей, предлагая полный спектр приложений, таких как мониторинг аварийных сигналов, мониторинг производительности, предоставление услуг, резервное копирование и восстановление, инвентаризация оборудования и управление программным обеспечением сетевых элементов.
                            NMS5 доступна в нескольких конфигурациях для удовлетворения различных потребностей, начиная от небольших сетей и заканчивая крупными операторами мобильной связи.
                            NMS5 готова к программной архитектуре SDN, что ускоряет переход к оркестрации многодоменной сети.
                        </p>
                    </div>
                </Container>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} />
            <OptionList4 options={options} title="Основные особенности и преимущества NMS5" />
        </>
    )
}

export default Nms5;